import { inject, Injectable } from '@angular/core';
import { LogService } from '../log/log.service';

@Injectable({
  providedIn: 'root',
})
export class CachingService {
  private readonly logService: LogService = inject(LogService);

  //insert or update the cache value of the call
  insertOrUpdateCache(apiUrl: string, jsonData: string): void {
    try {
      localStorage.setItem('full-' + apiUrl, jsonData);
    } catch (ex: Error | any) {
      this.logService.error('CACHING INSERT ERROR: ' + ex.message);
    }
  }

  getCache(apiUrl: string): any | undefined {
    const cacheUri = 'full-' + apiUrl;
    const request = localStorage.getItem(cacheUri);
    if (request) {
      return JSON.parse(request);
    }

    return undefined;
  }

  clearCache(): void {
    localStorage.clear();
  }
}
